<template>
  <div class="g-content">
    <div class="g-content-main common-main">
      <div class="system-item ">
        <div class="system-item-left">
          <!-- 用户统计 -->
          <div class="system-item-box" v-auth="['auth_system_dashboard_userCount']">
            <h4>{{ $t('system_dashboard_user') }}：</h4>
            <div class="system-item-content">
              <ul v-if="userStat">
                <li>
                  <label>{{ $t('system_dashboard_user_total') }}：</label>
                  <span>{{ userStat.totalNum | stat }}</span>
                </li>
                <!-- <li>
                <label>{{ $t('system_dashboard_user_online') }}：</label>
                <span>{{ userStat.onlineNum | stat }}</span>
              </li> -->
                <li>
                  <label>{{ $t('system_dashboard_user_disabled') }}：</label>
                  <span>{{ userStat.disableNum | stat }}</span>
                </li>
                <li class="system-item-btn">
                  <router-link
                    to="/manage/system/user/add"
                    v-auth.and="['auth_user', 'auth_user_list', 'auth_user_add']"
                  >
                    <a-button size="small" type="primary" style="margin-bottom:10px;" icon="plus">
                      {{ $t('com_btn_user_add') }}
                    </a-button>
                  </router-link>

                  <router-link
                    to="/manage/system/user/list"
                    v-auth.and="['auth_user', 'auth_user_list']"
                  >
                    <a-button size="small" type="primary" icon="plus">
                      {{ $t('com_btn_user_manage') }}
                    </a-button>
                  </router-link>
                </li>
              </ul>
            </div>
          </div>

          <!-- 客户统计 -->
          <div class="system-item-box" v-auth="['auth_system_dashboard_customerCount']">
            <h4>{{ $t('system_dashboard_customer') }}：</h4>
            <div class="system-item-content">
              <ul v-if="customerStat">
                <li>
                  <label>{{ $t('system_dashboard_customer_total') }}：</label>
                  <span>{{ customerStat | stat }} </span>
                </li>
                <li class="system-item-btn">
                  <router-link
                    to="/manage/system/customer/list"
                    v-auth.and="['auth_customer', 'auth_customer_list']"
                  >
                    <a-button size="small" type="primary" icon="pic-right">
                      {{ $t('com_btn_customer_manage') }}
                    </a-button>
                  </router-link>
                </li>
              </ul>
            </div>
          </div>

          <!-- 设备模型统计 -->
          <div class="system-item-box" v-auth="['auth_system_dashboard_modelCount']">
            <h4>{{ $t('system_dashboard_device_model') }}：</h4>
            <div class="system-item-content">
              <ul v-if="deviceModelStat">
                <li>
                  <label>{{ $t('system_dashboard_device_model_total') }}：</label>
                  <span>{{ deviceModelStat | stat }}</span>
                </li>
                <li class="system-item-btn" v-auth="['auth_deviceModel']">
                  <router-link to="/manage/system/device-model">
                    <a-button size="small" type="primary" icon="pic-right">
                      {{ $t('com_btn_device_model_manage') }}
                    </a-button>
                  </router-link>
                </li>
              </ul>
            </div>
          </div>

          <!-- 系统版本(不显示) -->
          <div class="system-item-box" v-auth="['auth_system_dashboard_info']">
            <h4>{{ $t('system_dashboard_info') }}：</h4>
            <div class="system-item-content">
              <ul v-if="systemInfo">
                <li>
                  <label>{{ $t('system_dashboard_info_mysql') }}：</label>
                  <span>{{ systemInfo.dbInfo | stat }}</span>
                </li>
                <li>
                  <label>{{ $t('system_dashboard_info_mqtt') }}：</label>
                  <span>{{ systemInfo.mqttInfo | stat }}</span>
                </li>
                <li>
                  <label>{{ $t('system_dashboard_info_nps') }}：</label>
                  <span>{{ systemInfo.npsInfo | stat }}</span>
                </li>
                <li>
                  <label>{{ $t('system_dashboard_info_redis') }}：</label>
                  <span>{{ systemInfo.redisInfo | stat }}</span>
                </li>
                <li>
                  <label>{{ $t('system_dashboard_info_frontend') }}：</label>
                  <span>{{ systemInfo.frontendInfo | stat }}</span>
                </li>
                <li>
                  <label>{{ $t('system_dashboard_info_backend') }}：</label>
                  <span>{{ systemInfo.backendInfo | stat }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="system-item-right">
          <!-- 最近系统事件 -->
          <div class="system-item-box" v-auth="['auth_system_dashboard_event']">
            <h4>{{ $t('system_dashboard_system_events') }}：</h4>
            <div class="system-item-content" style="padding:0;width:100%;">
              <a-table
                :columns="systemColumns"
                :data-source="systemEvent"
                bordered
                :rowKey="(_text, index) => index"
                :pagination="false"
                rowStyle="color:#000000"
                class="g-table g-table-no-border g-table-small"
                :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped' : null)"
                size="small"
                :scroll="{ x: true }"
                v-if="systemEvent"
              >
                <!-- 状态 -->
                <template slot="faultStatus" slot-scope="text">
                  <span v-if="text === 0">{{ $t('system_dashboard_table_open') }}</span>
                  <span v-else-if="text === 1">{{ $t('system_dashboard_table_ended') }}</span>
                  <span v-else>--</span>
                  <span></span>
                </template>

                <!-- 类型：故障类型，0-断线，1-轻微告警，2-告警，部分设备不可用，3-故障，系统不可用 -->
                <template slot="faultType" slot-scope="text">
                  <span v-if="$t('system_dashboard_system_events_types')[text]">
                    {{ $t('system_dashboard_system_events_types')[text] }}
                  </span>
                  <span v-else>--</span>
                </template>

                <!-- 开始时间 -->
                <template slot="timeStart" slot-scope="text">
                  {{ text | formatDate }}
                </template>

                <!-- 结束时间 -->
                <template slot="timeEnd" slot-scope="text">
                  {{ text | formatDate }}
                </template>

                <!-- 创建时间 -->
                <template slot="createTime" slot-scope="text">
                  {{ text | formatDate }}
                </template>
              </a-table>
            </div>
          </div>

          <!-- 最近添加用户 -->
          <div class="system-item-box" v-auth="['auth_system_dashboard_user']">
            <h4>{{ $t('system_dashboard_recent_user') }}：</h4>
            <div class="system-item-content" style="padding:0;width:100%;">
              <a-table
                :columns="userColumns"
                :data-source="recentUserList"
                bordered
                :rowKey="(_text, index) => index"
                :pagination="false"
                rowStyle="color:#000000"
                class="g-table g-table-no-border g-table-small"
                :showHeader="!!recentUserList.length"
                :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped' : null)"
                size="small"
                v-if="recentUserList"
              >
                <template slot="createTime" slot-scope="text">
                  {{ text | formatDate }}
                </template>
              </a-table>
            </div>
          </div>

          <!-- 最近添加客户 -->
          <div class="system-item-box" v-auth="['auth_system_dashboard_customerEvent']">
            <h4>{{ $t('system_dashboard_recent_customer') }}：</h4>
            <div class="system-item-content" style="padding:0;width:100%;">
              <a-table
                :columns="customerColumns"
                :data-source="recentCustomerList"
                bordered
                :rowKey="(_text, index) => index"
                :pagination="false"
                rowStyle="color:#000000"
                class="g-table g-table-no-border g-table-small"
                :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped' : null)"
                size="small"
                v-if="recentCustomerList"
              >
                <template slot="createTime" slot-scope="text">
                  {{ text | formatDate }}
                </template>
              </a-table>
            </div>
          </div>

          <!-- 最近添加设备模型 -->
          <div class="system-item-box" v-auth="['auth_system_dashboard_model']">
            <h4>{{ $t('system_dashboard_recent_device_model') }}：</h4>
            <div class="system-item-content" style="padding:0;width:100%;">
              <a-table
                :columns="deviceModelColumns"
                :data-source="recentDeviceModelList"
                bordered
                :rowKey="(_text, index) => index"
                :pagination="false"
                rowStyle="color:#000000"
                class="g-table g-table-no-border g-table-small"
                :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped' : null)"
                size="small"
                v-if="recentDeviceModelList"
              >
                <template slot="createTime" slot-scope="text">
                  {{ text | formatDate }}
                </template>

                <!-- 是否支持SSH -->
                <template slot="supportSsh" slot-scope="text">
                  {{ text ? $t('com_table_no') : $t('com_table_yes') }}
                </template>

                <!-- 是否支持WEB -->
                <template slot="supportWeb" slot-scope="text">
                  {{ text ? $t('com_table_no') : $t('com_table_yes') }}
                </template>

                <!-- 是否父级 -->
                <template slot="parentId" slot-scope="text">
                  {{ text ? $t('com_table_no') : $t('com_table_yes') }}
                </template>
              </a-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import * as API from '@/api/system/dashboard';

export default {
  components: {},

  data() {
    return {
      // 用户统计
      userStat: null,
      // 客户统计
      customerStat: null,
      // 设备模型统计
      deviceModelStat: null,
      // 系统信息
      systemInfo: null,
      // 系统事件
      systemEvent: null,
      recentUserList: null,
      recentCustomerList: null,
      recentDeviceModelList: null,

      systemColumns: [
        {
          title: '#',
          align: 'center',
          customRender: (text, record, index) => {
            return index + 1;
          },
        },
        {
          title: this.$t('system_dashboard_system_events_table_sn'),
          dataIndex: 'devSn',
          align: 'center',
        },

        {
          title: this.$t('system_dashboard_system_events_table_status'),
          dataIndex: 'faultStatus',
          align: 'center',
          scopedSlots: { customRender: 'faultStatus' },
        },

        {
          title: this.$t('system_dashboard_system_events_table_type'),
          dataIndex: 'faultType',
          align: 'center',
          scopedSlots: { customRender: 'faultType' },
        },

        {
          title: this.$t('system_dashboard_system_events_table_start_time'),
          align: 'center',
          dataIndex: 'timeStart',
          scopedSlots: { customRender: 'timeStart' },
        },

        {
          title: this.$t('system_dashboard_system_events_table_end_time'),
          align: 'center',
          dataIndex: 'timeEnd',
          scopedSlots: { customRender: 'timeEnd' },
        },

        {
          title: this.$t('com_table_created_time'),
          align: 'center',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
        },
      ],

      // user list
      userColumns: [
        {
          title: '#',
          align: 'center',
          customRender: (text, record, index) => {
            return index + 1;
          },
        },
        {
          title: this.$t('user_table_userName'),
          dataIndex: 'name',
          align: 'center',
        },

        {
          title: this.$t('user_table_nickName'),
          dataIndex: 'nickName',
          align: 'center',
        },

        {
          title: this.$t('user_table_email'),
          dataIndex: 'email',
          align: 'center',
        },

        {
          title: this.$t('com_table_created_time'),
          align: 'center',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
        },
      ],

      // customer
      customerColumns: [
        {
          title: '#',
          align: 'center',
          customRender: (text, record, index) => {
            return index + 1;
          },
        },
        {
          title: this.$t('com_table_name'),
          dataIndex: 'name',
          align: 'center',
        },
        {
          title: this.$t('com_table_code'),
          dataIndex: 'code',
          align: 'center',
        },

        {
          title: this.$t('com_table_created_time'),
          align: 'center',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
        },
      ],

      // device model
      deviceModelColumns: [
        {
          title: '#',
          align: 'center',
          customRender: (text, record, index) => {
            return index + 1;
          },
        },
        {
          title: this.$t('com_table_name'),
          dataIndex: 'name',
          align: 'center',
        },
        {
          title: this.$t('com_table_parent_model'),
          dataIndex: 'parentId',
          align: 'center',
          scopedSlots: { customRender: 'parentId' },
        },

        {
          title: `${this.$t('device_vpn_ssh')}?`,
          dataIndex: 'supportSsh',
          align: 'center',
          scopedSlots: { customRender: 'supportSsh' },
        },

        {
          title: `${this.$t('device_vpn_webui')}?`,
          dataIndex: 'supportWeb',
          align: 'center',
          scopedSlots: { customRender: 'supportWeb' },
        },

        {
          title: this.$t('com_table_created_time'),
          align: 'center',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
        },
      ],
    };
  },

  created() {
    this.type = this.$route.params.type || 'login';
    console.log(this.type);
    this.$store.commit('setPageLoading', false);
    this.loading = false;
    // 用户统计
    if (this.authList.includes('auth_system_dashboard_userCount') || this.isSuperAdmin) {
      this.getUserStat();
    }
    // 客户统计
    if (this.authList.includes('auth_system_dashboard_customerCount') || this.isSuperAdmin) {
      this.getCustomerStat();
    }
    // model统计
    if (this.authList.includes('auth_system_dashboard_modelCount') || this.isSuperAdmin) {
      this.getDeviceModelStat();
    }

    // 系统数据
    if (this.authList.includes('auth_system_dashboard_info') || this.isSuperAdmin) {
      this.getSystemInfo();
    }
    // 系统事件
    if (this.authList.includes('auth_system_dashboard_event') || this.isSuperAdmin) {
      this.getSystemEvent();
    }
    // 最近用户
    if (this.authList.includes('auth_system_dashboard_user') || this.isSuperAdmin) {
      this.getRecentUserList();
    }

    // 最近客户
    if (this.authList.includes('auth_system_dashboard_customerEvent') || this.isSuperAdmin) {
      this.getRecentCustomerList();
    }
    if (this.authList.includes('auth_system_dashboard_model') || this.isSuperAdmin) {
      this.getRecentDeviceModelList();
    }
  },
  computed: {
    ...mapGetters(['authList', 'isSuperAdmin']),
  },

  methods: {
    // 获取用户信息
    getUserStat() {
      API.UserStat().then(res => {
        if (res.code === 0) {
          this.userStat = res.data;
        }
      });
    },
    // 获取客户信息
    getCustomerStat() {
      API.CustomerStat().then(res => {
        if (res.code === 0) {
          this.customerStat = res.data;
        }
      });
    },
    // 获取设备模型
    getDeviceModelStat() {
      API.DeviceModelStat().then(res => {
        if (res.code === 0) {
          this.deviceModelStat = res.data;
        }
      });
    },
    // 获取系统信息
    getSystemInfo() {
      API.SystemInfo().then(res => {
        if (res.code === 0) {
          this.systemInfo = res.data;
        }
      });
    },
    // 获取系统事件
    getSystemEvent() {
      API.SystemEvent().then(res => {
        if (res.code === 0) {
          this.systemEvent = res.data || [];
        }
      });
    },
    // 最近添加用户
    getRecentUserList() {
      API.RecentUserList().then(res => {
        if (res.code === 0) {
          this.recentUserList = res.data || [];
        }
      });
    },
    // 最近添加客户
    getRecentCustomerList() {
      API.RecentCustomerList().then(res => {
        if (res.code === 0) {
          this.recentCustomerList = res.data || [];
        }
      });
    },
    getRecentDeviceModelList() {
      API.RecentDeviceModelList().then(res => {
        if (res.code === 0) {
          this.recentDeviceModelList = res.data || [];
        }
      });
    },
    getList() {},
  },
};
</script>

<style lang="less" scoped>
.system-item {
  display: flex;

  .system-item-left {
    // width: 40%;
    width: 200px;
  }

  .system-item-right {
    flex: 1;
    margin-left: 20px;
  }

  .system-item-box {
    border: #eee solid 1px;
    width: 100%;
    margin-bottom: 30px;

    h4 {
      background: #f9f9f9;
      padding: 10px 20px;
      border-bottom: #eee solid 1px;
      margin: 0;
      font-weight: bold;
      font-size: 16px;
    }
    ::v-deep .system-item-content {
      padding: 10px 20px;
      font-size: 16px;

      ul {
        li {
          padding: 5px 0;
          &.system-item-btn {
            padding: 20px 0 0;

            button {
              margin-right: 20px;
            }
          }
        }
      }

      .g-table {
        .ant-table-body {
          tr {
            &:last-child {
              td {
                border-bottom: none;
              }
            }
          }
        }

        .ant-table-placeholder {
          border-top: #eee solid 1px;
        }
      }
    }
  }
}
</style>
